import React from 'react';
import { ASSETS } from '../data/site';

// Reusable uppercase micro-label with accent line (newchem style)
export const SectionLabel = ({ children, className = '', center = false }) => (
  <div className={`flex items-center gap-3 ${center ? 'justify-center' : ''} ${className}`}>
    <span className="h-px w-10 bg-blue-600" aria-hidden="true" />
    <p className="text-[11px] font-bold uppercase tracking-[0.28em] text-blue-700">{children}</p>
  </div>
);

// Inner-page hero header used on all subpages
export const PageHeader = ({ label, title, lead, imageKey }) => {
  const bg = imageKey ? ASSETS[imageKey] : null;
  return (
    <section className="relative overflow-hidden border-b border-slate-200 bg-slate-50">
      {bg && (
        <div className="absolute inset-0 -z-0" aria-hidden="true">
          <img src={bg} alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-white via-white/90 to-white/60" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white" />
        </div>
      )}
      <div className="relative container-wide py-14 lg:py-20">
        <div className="max-w-3xl mk-fade-up">
          <SectionLabel>{label}</SectionLabel>
          <h1 className="mt-5 text-[30px] sm:text-[40px] lg:text-[46px] font-extrabold tracking-tight text-slate-900 leading-[1.08]">
            {title}
          </h1>
          {lead && <p className="mt-5 text-[15px] sm:text-base text-slate-600 leading-relaxed max-w-2xl">{lead}</p>}
        </div>
      </div>
    </section>
  );
};

export default PageHeader;
